import Vue from 'vue'
import cart from '@/lib/cart'
import state from '@/lib/appState'
import {
  formatMoney,
  getVariantName,
  mapProductCollectionsToGa4Categories,
  getProductFullName,
  deepClone,
  decode,
  getProductGiftMessage,
  formatPrice
} from '@/lib/util'
import '../product-subscription/product-subscription.vue'
import '../select-input/select-input.vue'
import { trigger } from '@/lib/utils'

Vue.component('product-form', {
  props: [
    'addToCartText',
    'soldOutText',
    'unavailableText',
    'giftProduct',
    'productFreeGiftMessage',
    'isFormBar',
    'isGiftCard'
  ],
  data () {
    const product = window.BARREL.product
    return {
      state,
      product,
      quantity: 1,
      min: 1,
      error: '',
      errorAddTocart: '',
      isProcessing: false,
      checkedGiftCard: false,
      giftCardFormInput: '',
      isGiftCardFormError: false
    }
  },
  watch: {
    'state.selectedOptions': {
      handler () {
        this.pickActiveVariant()
      },
      deep: true
    },
    'activeVariant': {
      handler () {
        this.updateProductStatus()
      }
    },
    giftCardFormInput (val) {
      this.isGiftCardFormError = val.length === 0
    },
    deep: true
  },
  mounted () {
    this.setSubscriptionDefaults()
  },
  methods: {
    getProductFullName,
    setSubscriptionDefaults () {
      const options = this.product['options_with_values'].reduce((obj, option) => {
        obj[option.name] = option.values[0]
        return obj
      }, {})
      options.purchaseType = 'onetime'
      state.selectedOptions = options
    },
    updateQuantity (value) {
      this.quantity = value
      const inventoryQuantity = this.activeVariant.inventory_quantity
      const newQuantity = inventoryQuantity
        ? Math.min(this.quantity, inventoryQuantity)
        : this.quantity

      this.quantity = Math.max(this.min, newQuantity)
    },
    pickActiveVariant () {
      const {
        variants = [],
        options = [],
        variants_metafields = []
      } = this.product

      for (let i = 0; i < variants.length; i++) {
        let variant = variants[i]
        const isMatch = options.every((option, _i) => {
          return (
            variant[`option${_i + 1}`] === state.selectedOptions[option]
          )
        })
        if (isMatch) {
          const metafields = variants_metafields.find(metafield => metafield.id === variant.id)
          if (metafields && metafields.available_at) {
            variant.availableAt = metafields.available_at
          }
          state.activeVariant = variant
          break
        } else {
          state.activeVariant = {}
        }
      }
    },
    updateSelectedOption (name, value) {
      this.state.selectedOptions[name] = value
      this.error = ''
    },
    onSelectChange ({ name, value }) {
      this.updateSelectedOption(name, value)
      if (this.isGiftCard == 'true') {
        this.updateGiftCardOption(value)
      }
    },
    updateGiftCardOption (value) {
      const selectEls = document.querySelectorAll('[data-product-select]')

      selectEls.forEach(select => {
        const selectedOption = select.querySelector(`[data-title='${value}']`)
        if (selectedOption && !selectedOption.disabled) {
          selectedOption.selected = true
        }
      })
    },
    addGTM () {
      const productVariantName = this.activeVariant.title
      const ga4Item = {
        item_id: this.product.id,
        item_name: this.getProductFullName(
          this.product.title,
          productVariantName
        ),
        index: 0,
        item_brand: this.product.vendor,
        item_list_id: 'pdp',
        item_list_name: 'PDP',
        item_variant: getVariantName(productVariantName),
        price: this.formattedPrice,
        quantity: this.quantity,
        ...mapProductCollectionsToGa4Categories(this.product.collection),
      }

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: this.formattedPrice,
          items: [ga4Item],
        },
      })
    },
    generateBundleId () {
      return Math.floor(Date.now() / 1000)
    },
    addKlaviyoEvent () {
      let _learnq = window._learnq || []
      const klaviyoItem = {
        Name: this.product.title,
        ProductID: this.product.id,
        Categories: this.product.collection,
        ImageURL: `https:${this.product.featured_image}`,
        URL: `${window.location.origin}/products/${this.product.handle}`,
        Brand: this.product.vendor,
        Price: formatMoney(this.activeVariant.price),
        CompareAtPrice: formatMoney(this.product.compare_at_price_max)
      }
      _learnq.push(['track', 'Added to Cart', klaviyoItem])
    },
    async addToCart () {
      if (this.checkedGiftCard && !this.giftCardFormInput.length) {
        this.isGiftCardFormError = true
        return
      }
      this.addGTM()
      this.isProcessing = true
      this.errorAddTocart = ''
      const variants = []
      this.groupId = this.generateBundleId()
      const groupName = '_groupID'

      const addToCartStatus = this.$refs.addToCartStatus
      if (addToCartStatus) {
        addToCartStatus.setAttribute('aria-hidden', false)

        setTimeout(() => {
          addToCartStatus.setAttribute('aria-hidden', true)
        }, 1000)
      }

      const properties = {
        _item_list_id: 'pdp',
        _item_list_name: 'PDP'
      }
      if (this.product.collection) {
        properties['_collection'] = this.product.collection.join('|')
      }

      if (this.isGiftCard == 'true' && this.checkedGiftCard) {
        const recipientEmailValue = this.$refs.inputRecipientEmail?.value
        const recipientNameValue = this.$refs.inputRecipientName?.value
        const messageValue = this.$refs.inputMessage?.value
        const sendOnValue = this.$refs.inputSendOn?.value
        properties['__shopify_offset'] = new Date().getTimezoneOffset().toString()
        properties['__shopify_send_gift_card_to_recipient'] = 'on'
        properties['Recipient email'] = recipientEmailValue ? recipientEmailValue : ''
        properties['Recipient name'] = recipientNameValue ? recipientNameValue : ''
        properties['Message'] = messageValue ? messageValue : ''
        properties['Send on'] = sendOnValue ? sendOnValue : ''
      }

      const options = {
        id: this.activeVariant.id,
        quantity: this.quantity,
        properties: deepClone(properties),
      }

      if (this.state.selectedOptions.purchaseType === 'autodeliver') {
        options.sellingPlanId = parseFloat(state.selectedOptions['planId'])
      }
      if (this.giftProductDefaultData && Object.keys(this.giftProductDefaultData).length > 0) {
        options.properties = deepClone({
          [groupName]: this.groupId
        })
        variants.push(options)
        const message = this.productFreeGiftMessage || 'Free gift with <<product_title>>'
        variants.push({
          id: this.giftProductDefaultData.firstAvailableVariant.id,
          quantity: 1,
          properties: {
            _is_free_gift: 'true',
            _free_gift_owner: this.product.title,
            _free_gift_owner_id: this.product.id,
            _free_gift_message: getProductGiftMessage(message, this.product.title),
            [groupName]: this.groupId
          }
        })
      } else {
        variants.push(options)
      }

      cart.add(variants).then((code) => {
        if (code.status === 422) {
          this.error = code.description
          return
        }
        cart.get().then((data) => {
          state.cart = data
          trigger('mini-cart-open', document.body, data)
          this.isProcessing = false
          trigger('update-gwp', document.body)
        })
      })
      this.addKlaviyoEvent()
    },
    getOptionValue (option) {
      if (state.selectedOptions) {
        return state.selectedOptions[option]
      }
    },
    updateProductStatus () {
      const productStatus = this.$refs.productStatus
      if (!productStatus) {
        return
      }

      productStatus.textContent = this.liveRegionText()
      productStatus.setAttribute('aria-hidden', false)

      setTimeout(() => {
        productStatus.setAttribute('aria-hidden', true)
      }, 1000)
    },
    liveRegionText () {
      let liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]'

      if (Object.keys(this.activeVariant).length === 0) {
        return 'Unavailable'
      }

      // Update availability
      const availability = this.activeVariant.available ? '' : 'Sold out,'
      liveRegionText = liveRegionText.replace('[Availability]', availability)

      // Update pricing information
      let regularLabel = ''
      let regularPrice = formatMoney(this.activeVariant.price)

      let saleLabel = ''
      let salePrice = ''

      if (this.activeVariant.compare_at_price > this.activeVariant.price) {
        regularLabel = 'Regular price'
        regularPrice = formatMoney(this.activeVariant.compare_at_price) + ','

        saleLabel = 'Sale price'
        salePrice = formatMoney(this.activeVariant.price)
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim()

      return liveRegionText
    },
  },
  computed: {
    isBar() {
      return this.isFormBar
    },
    giftProductDefaultData () {
      if (!this.giftProduct) {
        return []
      }
      const giftProductData = JSON.parse(decode(this.giftProduct))
      const giftProduct = giftProductData.length ? giftProductData.filter(item => item.available) : null
      return giftProduct.length ? giftProduct[0] : null
    },
    formattedPrice () {
      const price = formatMoney(this.activeVariant.price)
      const productPriceEls = document.querySelectorAll('[data-product-price]')
      productPriceEls.forEach(el => el.innerText = price)
      return price
    },
    hasVariant () {
      return Object.keys(this.activeVariant).length
    },
    maximumQuantity () {
      /**
       * Variant does't exist or
       * is sellable when out of stock or
       * is out of stock
       */
      if (
        !this.hasVariant ||
        this.activeVariant.inventory_policy === 'continue' ||
        !this.activeVariant.available
      ) {
        return null
      }

      return this.activeVariant.inventory_quantity !== -1 ? this.activeVariant.inventory_quantity : Number.POSITIVE_INFINITY
    },
    activeVariant () {
      return this.state.activeVariant
    },
    selectedOptions () {
      return this.state.selectedOptions
    },
    submitButtonText () {
      if (!this.hasVariant) {
        return this.unavailableText
      }

      return this.activeVariant.available
        ? this.addToCartText
        : this.soldOutText
    },
    onetimeVariantPrice () {
      return formatMoney(parseFloat(this.activeVariant.price))
    },
    subscriptionSavePrice () {
      if (this.subscriptionDiscountType === 'percentage') {
        return formatMoney(parseFloat((100 - this.subscriptionDiscount) * this.activeVariant.price / 100))
      } else {
        return formatMoney(parseFloat(this.activeVariant.price - this.subscriptionDiscount))
      }
    },
    subscriptionDiscountType () {
      return this.sellingPlan ? this.sellingPlan[0].price_adjustments[0].value_type : 'percentage'
    },
    subscriptionDiscount () {
      return this.sellingPlan ? this.sellingPlan[0].price_adjustments[0].value : 0
    },
    sellingPlan () {
      return this.product.selling_plan_groups && this.product.selling_plan_groups.length ? this.product.selling_plan_groups[0].selling_plans : null
    },
  },
})
